import { makeAutoObservable } from "mobx";
import { OrganizationSettings } from "../app/pages/invoices/core/_models";

interface CompanyObject {
  name: string;
  name_en?: string;
  commercial_registration: string;
  entity_number: string;
  logo_url?: string;
  id?: string;
  refund_policy?: {
    en?: string;
    ar?: string;
  };
  vat_number?: string;
  settings?: OrganizationSettings;
}

class Company {
  name?: string;
  name_en?: string;
  commercial_registration?: string;
  entity_number?: string;
  logo_url?: string;
  id?: string;
  refund_policy?: {
    en?: string;
    ar?: string;
  };
  vat_number?: string;
  settings?: OrganizationSettings;

  constructor() {
    makeAutoObservable(this);
  }

  setCompany({
    name,
    commercial_registration,
    entity_number,
    logo_url,
    id,
    refund_policy,
    vat_number,
    settings,
    name_en,
  }: CompanyObject): void {
    this.name = name;
    this.commercial_registration = commercial_registration;
    this.entity_number = entity_number;
    this.logo_url = logo_url;
    this.id = id;
    this.refund_policy = refund_policy;
    this.vat_number = vat_number;
    this.settings = settings;
    this.name_en = name_en;
  }

  setLogoUrl(logo_url: string): void {
    this.logo_url = logo_url;
  }

  updateSettings(newSettings: OrganizationSettings): void {
    this.settings = {
      ...this.settings, // Preserve existing settings
      ...newSettings, // Merge new settings
    };
  }
}

export default Company;
